import { useCheckboxState } from '@vtex/admin-ui'
import { FormState, Select, useWatch } from '@vtex/admin-ui-form'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { SubscriptionFrequency, SubscriptionFrequencyUnit } from 'typings'
import { CollapsibleCheckbox } from '../../../../CollapsibleCheckbox'
import { styles } from '../styles'
import { NumberInput } from '../../../../NumberInput'
import { messages } from '../messages'

type Props = {
  name: string
  form: FormState
}

export function FrequencyFilter(props: Props) {
  const { name, form } = props

  const { frequency: frequencyMessages } = messages.editor
  const { $t } = useIntl()

  const frequency: SubscriptionFrequency | undefined = useWatch({
    form,
    name,
  })

  const checkboxState = useCheckboxState({
    initialValue: Boolean(frequency),
  })

  useEffect(() => {
    if (!checkboxState.value) {
      form.setValue(name, undefined)
      form.clearErrors(name)
    }
  }, [checkboxState.value, name, form])

  return (
    <CollapsibleCheckbox
      label={$t(frequencyMessages.label)}
      state={checkboxState}
    >
      <div className={styles.flexRow}>
        <NumberInput
          name={`${name}.value`}
          state={form}
          label={$t(frequencyMessages.value)}
          fractionDigits={0}
        />
        <Select
          name={`${name}.unit`}
          state={form}
          defaultValue={SubscriptionFrequencyUnit.MONTH}
          className={styles.unit}
          onChangeCapture={() => form.clearErrors(name)}
        >
          {Object.values(SubscriptionFrequencyUnit).map((value) => (
            <option key={value} value={value}>
              {$t(frequencyMessages.unit[value])}
            </option>
          ))}
        </Select>
      </div>
    </CollapsibleCheckbox>
  )
}
